<template>
  <v-container text-xs-center fluid>
    <v-card rounded-pill width="1100px" class="pa-1 mb-1 mt-2 mx-auto" outlined color="transparent">
    <v-form>
      <v-layout wrap >

      <v-select dense outlined rounded class="ma-1" style="height: 40px; width: 50px;" 
  
        id="farm" 
        ref="farm" 
        label="사업장" 
        v-model="farm"
        :items="farmItems"
        :menu-props="{ top: false, offsetY: true }"
        no-data-text="자료(권한)이 없습니다."
        item-text="name"
        return-object
        @change="changeFarm()"
        @focus="comboFarms()"
      />

      <v-select dense outlined  rounded class="ma-1" style="height: 40px; width: 50px;"
          id="building" 
          ref="building" 
          label="축사/건물/구역" 
          v-model="building"
          :items="buildingItems"
          :menu-props="{ top: false, offsetY: true }"
          no-data-text="자료(권한)이 없습니다."
          item-text="name"
          return-object
          @change="changeBuilding()"
          @focus="comboBuildings()"
          clearable
        />
    </v-layout>

    <v-layout justify-center>
      <v-menu
        v-model="menu1"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field dense outlined  
            class="calendar shrink rounded mt-1 ml-1 mb-1"
            id="fr_date" 
            ref="fr_date" 
            v-model="fr_date"
            label="부터"
            append-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          no-title locale="ko-KR"
          v-model="fr_date"
          @input="menu1 = false"
        ></v-date-picker>
      </v-menu>
      <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field dense outlined 
            class="calendar shrink rounded mt-1 ml-1  mb-1 mr-1"
            id="to_date" 
            ref="to_date" 
            v-model="to_date"
            label="까지"
            append-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          no-title locale="ko-KR"
          v-model="to_date"
          @input="menu2 = false"
        ></v-date-picker>
      </v-menu>
    </v-layout>

    <div class="custom-slider">
      <v-slider
        label="시간"
        track-color="#3a4f3f"
        color="#c1dfc4"
        :loading="loading" 
        v-model="term"
        :tick-labels="['15분','30분','1시간','3시간','6시간','일별']"
        :max="5"
        step="1"
        ticks="always"
        @change="refreshList()"
      >
      <!-- <template v-slot:thumb-label="item">
        {{item.value}}
      </template> -->
      </v-slider>

      <v-btn class="normal-btn ml-1"
        id="refreshList" 
        :loading="loading" 
        ref="refreshList" 
        type="submit" 
        @click.prevent="refreshList()">
        <v-icon>
          mdi-magnify
        </v-icon>
        <span> 조회 </span>
      </v-btn>
    </div>

    <div class="btn__container" >
      <v-btn outlined
        class="show__btn mr-1"
        :disabled = "!showList"
        @click="showList = false; refreshList()"
      >
        <v-icon color=#ffffff size="20">mdi-chart-line</v-icon>
        <span class="ml-1"> 차트 </span>
        <!-- <v-icon right dark>mdi-chart-line</v-icon> -->
      </v-btn>

      <v-btn outlined
        class="show__btn"
        :disabled = "showList"
        @click="showList = true; refreshList()"
      >
        <v-icon color=#ffffff size="20">mdi-table</v-icon>
        <span class="ml-1"> 목록 </span>
        <!-- <v-icon right dark>mdi-view-list</v-icon> -->
      </v-btn>
    </div>
    </v-form>
    </v-card>

    <div class="item__container">
      <WattList :items="listData" :items_daily="listData_daily" :loadingTable="loading" :divisionTerm= "term" v-show="showList"  />
      <WattChart :trendData1="trendData1" v-show="!showList" />
    </div>
 </v-container>
</template>

<script>
import Apis from '@/api/apis'
import VueCookies from "vue-cookies";
import dateUtil from "@/utils/custom/dateProperty.js";
import WattList from "./child/WattList.vue";
import WattChart from "./child/WattChart.vue";

export default {
  name: 'WattageDetail',
  components: {
    WattList,
    WattChart,
  },
  async created() {
    Apis.pageCount({
      page_name: this.$route.name,
      url: this.$route.path,
      division: "app",
    },() => {  // 정상처리
      // console.log("pageCount 호출",res);
    }).catch( (err) => {  // 개별 API 오류 처리 예제
      console.log("pageCount 호출 오류",err);
    });
    await this.comboFarms();
    await this.comboBuildings();

    let cdate = new Date();
    this.to_date= dateUtil.format(cdate, "yyyy-MM-dd");
    let frdate = new Date(cdate.setDate(cdate.getDate() - 3));
    this.fr_date= dateUtil.format(frdate, "yyyy-MM-dd");

    let cookie_info = VueCookies.get("watt_info");
    if (cookie_info) {
      this.showList = cookie_info.showList;
      this.term = cookie_info.term;
    }
    if (!this.isNull(this.$route.params)) {
      // console.log("Params : ", this.$route.params);
      this.company = this.$route.params.company;
      this.farm = this.$route.params.farm;
      this.building =this.$route.params.building;
    } else if (cookie_info) {
          this.company = cookie_info["company"] || {};
          this.farm = cookie_info.farm || {};
          this.building = cookie_info.building || {};
    } else {
      this.company = {code: this.farm.company_cd, name: this.farm.company_name};
      this.farm = {code: this.farm.code, name: this.farm.name};
      this.building = {code:this.building.code, name:this.building.name}
    }
    this.refreshList();
  },
  data () {
    return {

      showList: false,

      loading: false,
      company:{},
      farm : {},
      farmItems : [],
      building:{},
      buildingItems: [],

      term: 2,
      fr_date: "",
      to_date: "",

      menu1: false,
      menu2: false,

      listData: [],
      listData_daily: [],

      trendData: {},
      trendData1: {},
      
    }
  },
  methods: {
    refreshList() {
      if  (!this.fr_date) {
        alert("조회 시작일 선택하세요");
        this.$refs.fr_date.focus();
        return;
      }
      if  (!this.to_date) {
        alert("조회 시작일 선택하세요");
        this.$refs.to_date.focus();
        return;
      }
      this.$store.commit("resMessage","");
      this.loading = true;


      this.listData = [];
      this.listData_daily = [];

      if (this.term < 5) {   // 시간별 
        Apis.listTimelyKepcoData({ 
          company_cd: this.farm.company_cd,
          farm_cd: this.building && this.building.code || this.farm.code,
          fr_dt: this.fr_date,
          to_dt: this.to_date,
          start_time: "00:00:00",
          end_time: "23:59:59",
          timeDivision: this.term === 0 ? 15 : this.term === 1 ? 30 : this.term === 2 ? 60 : this.term === 3 ? 180 : 360,
          },(res) => {  
            if (res.result) {
              // console.log(this.company)
              this.listData = res.data.datalist;
              this.listData.forEach(element => {
                  if (element.watt_sum) element.watt_sum = Number(element.watt_sum).toFixed(2);
                  if (element.w_hum) element.w_hum = Number(element.w_hum).toFixed(0);
                  if (element.w_ps) element.w_ps = Number(element.w_ps).toFixed(0);
                  if (element.w_ws) element.w_ws = Number(element.w_ws).toFixed(1);
                  if (element.w_temp) element.w_temp = Number(element.w_temp).toFixed(1);
                });

              // console.log("resdata",res.data.datalist);

              if (!this.showList) {
                // 챠트 데이타

                let watt_time = [];
                let watt_array1 = [];

                let temp_time = [];
                let temp_array1 = [];

                let hum_time = [];
                let hum_array1 = [];

                let pres_time = [];
                let pres_array1 = [];

                let wind_time = [];
                let wind_array1 = [];

                this.listData.forEach(function (item) {
                  if  (item.watt_sum && !isNaN(item.watt_sum) && item.w_temp && !isNaN(item.w_temp)) {
                    watt_time.push(item.checkDateTime.substring(5,16));
                    watt_array1.push( Number(item.watt_sum));

                    item.w_temp && !isNaN(item.w_temp) && temp_time.push(item.checkDateTime.substring(5,16)) || temp_time.push(item.checkDateTime.substring(5,16));
                    item.w_temp && !isNaN(item.w_temp) && temp_array1.push(Number(item.w_temp)) || temp_array1.push(null);

                    item.w_hum && !isNaN(item.w_hum) && hum_time.push(item.checkDateTime.substring(5,16)) || hum_time.push(item.checkDateTime.substring(5,16));
                    item.w_hum && !isNaN(item.w_hum) && hum_array1.push(Number(item.w_hum)) || hum_array1.push(null);

                    item.w_ps && !isNaN(item.w_ps) && pres_time.push(item.checkDateTime.substring(5,16)) || pres_time.push(item.checkDateTime.substring(5,16));
                    item.w_ps && !isNaN(item.w_ps) && pres_array1.push(Number(item.w_ps)) || pres_array1.push(null);

                    item.w_ws && !isNaN(item.w_ws) && wind_time.push(item.checkDateTime.substring(5,16)) || wind_time.push(item.checkDateTime.substring(5,16));
                    item.w_ws && !isNaN(item.w_ws) && wind_array1.push(Number(item.w_ws)) || wind_array1.push(null);
                  }
                })  
                
                // console.log("temp_array",temp_array.length);
                this.trendData1 = {
                  watt_time : watt_time,
                  watt: watt_array1,

                  temp_time : temp_time,
                  temp: temp_array1,
                  
                  hum_time: hum_time,
                  hum: hum_array1,

                  pres_time: pres_time,
                  pres: pres_array1,

                  wind_time: wind_time,
                  wind: wind_array1,
                }

                // console.log(this.trendData1.pres)

              }
          
              this.$store.commit("resMessage",res.message);
              let cookie_info = { company: this.farm.company_cd, farm: this.farm, showList: this.showList, term: this.term, building:this.building };
              VueCookies.set("watt_info" ,cookie_info,"30d");
            } else {
              alert(res.message);
            }
            this.loading = false;

            if(this.$route.params.building == null){
                this.$refs.farm.focus();
            }else{
              this.$refs.building.focus();
            }

            // this.$refs.farm.focus();
            // this.$refs.refreshList.focus();

          }).catch( (err) => {  // API 오류 처리
              console.log("listTimelyKepcoData API 호출 오류",err)
              alert(err);
              this.loading = false;
          }
        )
        } else {    // 일별
          Apis.kepcoDataDailyView({
            farm_cd: this.building && this.building.code || this.farm.code ,
            fr_date: this.fr_date,
            to_date: this.to_date,
            },(res) => {  
              if (res.result) {
                // console.log(res.data);
                this.listData_daily = res.data;
                // console.log(this.listData_daily);

                if (!this.showList) {
                  let watt_time = [];
                  let watt_array1 = [];

                  let temp_time = []
                  let temp_avg = [];
                  let temp_high = [];
                  let temp_low = [];
                  
                  let hum_time = []
                  let hum_avg = [];
                  let hum_high = [];
                  let hum_low = [];

                  let pres_time = []
                  let pres_avg = [];
                  let pres_high = [];
                  let pres_low = [];

                  let wind_time = []
                  let wind_avg = [];
                  let wind_high = [];
                  let wind_low = [];

                  res.data.forEach(function (item) {
                    if  (!isNaN(item.watt_sum)) {
                      watt_time.push(item.checkDate.substring(5));
                      watt_array1.push(Number(item.watt_sum));

                      !isNaN(item.w_temp_average) && temp_time.push(item.checkDate.substring(5))|| temp_time.push(item.checkDateTime.substring(5,16));
                      !isNaN(item.w_temp_average) && temp_avg.push(Number(item.w_temp_average))|| temp_avg.push(null);
                      !isNaN(item.w_temp_highest) && temp_high.push(Number(item.w_temp_highest))|| temp_high.push(null);
                      !isNaN(item.w_temp_lowest) && temp_low.push(Number(item.w_temp_lowest))|| temp_low.push(null);

                      !isNaN(item.w_hum_average) && hum_time.push(item.checkDate.substring(5))|| hum_time.push(item.checkDateTime.substring(5,16));
                      !isNaN(item.w_hum_average) && hum_avg.push(Number(item.w_hum_average))|| hum_avg.push(null);
                      !isNaN(item.w_hum_highest) && hum_high.push(Number(item.w_hum_highest))|| hum_high.push(null);
                      !isNaN(item.w_hum_lowest) && hum_low.push(Number(item.w_hum_lowest))|| hum_low.push(null);                      

                      !isNaN(item.w_ps_average) && pres_time.push(item.checkDate.substring(5))|| pres_time.push(item.checkDateTime.substring(5,16));
                      !isNaN(item.w_ps_average) && pres_avg.push(Number(item.w_ps_average))|| pres_avg.push(null);
                      !isNaN(item.w_ps_highest) && pres_high.push(Number(item.w_ps_highest))|| pres_high.push(null);
                      !isNaN(item.w_ps_lowest) && pres_low.push(Number(item.w_ps_lowest))|| pres_low.push(null);       

                      !isNaN(item.w_ws_average) && wind_time.push(item.checkDate.substring(5))|| wind_time.push(item.checkDateTime.substring(5,16));
                      !isNaN(item.w_ws_average) && wind_avg.push(Number(item.w_ws_average))|| wind_avg.push(null);
                      !isNaN(item.w_ws_highest) && wind_high.push(Number(item.w_ws_highest))|| wind_high.push(null);
                      !isNaN(item.w_ws_lowest) && wind_low.push(Number(item.w_ws_lowest))|| wind_low.push(null);     
                    }
                  })  
                  // console.log("temp_array",temp_array.length);
                  this.trendData1 = {
                    watt_time: watt_time,
                    watt_daily: watt_array1,

                    temp_time: temp_time,
                    temp_avg: temp_avg,
                    temp_high: temp_high,
                    temp_low: temp_low,

                    hum_time: hum_time,
                    hum_avg: hum_avg,
                    hum_high: hum_high,
                    hum_low: hum_low,

                    pres_time: pres_time,
                    pres_avg: pres_avg,
                    pres_high: pres_high,
                    pres_low: pres_low,

                    wind_time: wind_time,
                    wind_avg: wind_avg,
                    wind_high: wind_high,
                    wind_low: wind_low
                  }
                  // console.log(this.trendData1)
                }  
                this.$store.commit("resMessage",res.message);
                let cookie_info = { company: this.company, farm: this.farm, showList: this.showList, term: this.term, building:this.building };
                VueCookies.set("barometer_info" ,cookie_info,"30d");

              } else {
                alert(res.message);
              }
              this.loading = false;

              if(this.$route.params.building == null){
                this.$refs.farm.focus();
              }else{
                this.$refs.building.focus();
              }
            }).catch( (err) => {  // API 오류 처리
                console.log("kepcoDataDailyView API 호출 오류",err)
                alert(err);
                this.loading = false;
            }
          )
        } 
    },
    async comboFarms() {
      // console.log("콤보팜스",this.company || "");
      await Apis.comboFarms({
        company_cd: "" ,
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          if (res.result) {
            // console.log("콤보res",res.data);
            this.farmItems = [];
            for (let i in res.data) {
            this.farmItems.push({
              company_cd: res.data[i].company_cd, 
              company_name: res.data[i].company_name, 
              code: res.data[i].farm_cd,
              name: res.data[i].farm_name,
              });
            }  
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboFarms API 호출 오류",err)
        }
      ) 
    },
    changeFarm() {      // 하위콤보 선택시 상위 콤보 동시 세팅, 하위콤보 지우기
      if (this.farm && this.farm.company_cd) {
        this.company = {code: this.farm.company_cd, name: this.farm.company_name};
      }
      this.refreshList();
    },
    async comboBuildings() {
      await Apis.comboBuildings({
        company_cd:this.company &&  this.company.code || "",
        farm_cd: this.farm && this.farm.code || "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          if (res.result) {
            // console.log("콤보res",res.data);

            this.buildingItems = [];

            for (let i in res.data) {
            // console.log(this.buildingItems)
            this.buildingItems.push({
              company_cd: res.data[i].company_cd, 
              company_name: res.data[i].company_name, 
              farm_cd: res.data[i].farm_cd, 
              farm_name: res.data[i].farm_name, 
              code: res.data[i].building_cd,
              name: res.data[i].building_name,
              });
            }  
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboBuildings API 호출 오류",err)
        }
      ) 
    },
    changeBuilding() {      // 하위콤보 선택시 상위 콤보 동시 세팅, 하위콤보 지우기
      if (this.building && this.building.company_cd) {
        this.company = {code: this.building.company_cd, name: this.building.company_name};
        this.farm = {code: this.building.farm_cd, name: this.building.farm_name};
        // this.building = {code: this.building.building_cd, name: this.building.building_name};
      }
      this.refreshList();
        // this.room = {};
    },

  }  // -----------methods 

}
</script>

<style>
.v-main__wrap{
  background-color:#f9f9f9;
}
.back__btn{
  min-width: 40px !important;
  width:40px !important;
  height:40px !important; 
  border-color:transparent;
  border-radius: 50%;
  align-content: center !important;
  font-weight: bold !important;
  background-image: linear-gradient(to top, #e4e8d4 0%, #ddefdc 100%);
  margin:5px 5px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.3);
}
.custom-slider{
  padding:5px 0 0 5px;
  /* margin-top:5px; */
  /* width:95%; */
  display:flex;
}
.v-slider__track-container {
  height: 10px !important;
}
.v-slider__track-background{
  border-radius:10px !important;
  background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%) !important;
}
.v-slider__track-fill{
  border-radius:10px 0 0 10px !important;
  background-image: linear-gradient(-20deg, #00cdac 0%, #8ddad5 100%) !important;

}
.v-slider__tick{
  width:0px !important;
  height: 0px !important;;
}
.v-slider__tick-label, .v-label{
  font-size:13px !important;
  letter-spacing: -1.25px;
  margin-top: 5px;
  display:block
}
.v-slider__thumb{
  width:15px !important;
  height:15px !important;
  background-color: #00cdac !important;
  /* border:1px solid white !important; */
}
.v-input__control { 
  border-radius: 100px !important; 
}
.calendar{
  width:50%;
  height:40px;
  background-color:white;
}
.normal-btn{
  width:70px;
  height:40px;
  border-radius: 30px;
  margin-top:5px;
  align-content: center !important;
  font-weight: bold !important;
  background-color: #3a4f3f !important;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.5);
}
.normal-btn > span {
  color:white;
  letter-spacing: -0.74px;
}

.btn__container{
  display:flex;
  justify-content: center;
  margin-top:15px;
  margin-bottom:10px;
}
.show__btn{
  width:150px;
  height:40px !important;
  border-radius:20px;
  font-size:18px !important;
  letter-spacing: -2px;
  background-color:#eaeaea;
  color:#e4e4e4 !important;
  transition: all 0.3s ease 0s;
}
.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn-outlined) {
  border: none;
  border-radius: 45px;
  background: #e4e8d4;
  background-image: linear-gradient(to top, #e4e8d4 0%, #ddefdc 100%);
  box-shadow: 5px 5px 5px 0px rgba(0,0,0,0.2);
  transition: all 0.3s ease 0s;
}
.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn-outlined) > .v-btn__content {
  color:#3a4f3a !important;
  font-weight:700;
  letter-spacing: -0.74px;
}
.v-btn__content{
  color:rgb(158, 158, 158);
}
.container{
  margin:0;
  padding:0;
}
.item__container{
  /* margin-top:-10px; */
  padding-left:5px;
  padding-right:5px;
}
.icon__temp{
  width:30px;
} 
.v-text-field--outlined fieldset {
  border-color: #3a4f3f !important
}
</style>

